// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l8FIJ","newExpiryDate":"styles_newExpiryDate__IyTZ_","footer":"styles_footer__3l441"};